module.exports = __webpack_public_path__ + "static/media/chevron-down.2ae05342.svg";